function popUpAddClass(){
    const clk_here = document.querySelector(".deductible a.sk-modal-button");
    if (clk_here) {
        clk_here.addEventListener("click", (event) => {
            event.preventDefault();
            const modaldiv = document.querySelector("#root");
            if(modaldiv){
                modaldiv.classList.add('sk_modal_offers');
            }
        });
    }
}

export { popUpAddClass };